import { updateObject } from '../../utils/utility';
import { AUTH_START, AUTH_LOGOUT, AUTH_SUCCESS, AUTH_GETFROMTOKEN_SUCCESS, AUTH_FAIL, SET_AUTH_REDIRECT_PATH, AUTH_ROLE_LOADED, AUTH_TEACHER_LOADED } from "../actionTypes";
import axios from "axios";
import instance from "../axiosApi";
import { clearAuthStorage } from "../../utils/authSession";


const initialState =  {
  id: localStorage.getItem('token-id'),
  userId: localStorage.getItem('userId'),
  username: localStorage.getItem('username'),
  roleName: localStorage.getItem('roleName') || null,
  teacherId: localStorage.getItem('teacherId') ? Number(localStorage.getItem('teacherId')) : null,
  roleLoaded: !!localStorage.getItem('roleName'),
  error: null,
  auth: {},
  loading: false,
  authRedirectPath: '/',
  token: null

}


// const initialState = {
//     isAuthenticated: false, // state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()) ,
//     auth: {}
//     // auth: {
//     //     "id": 40,
//     //     "firstName": "fred",
//     //     "lastName": "hansen",
//     //     "middleName": null,
//     //     "username": "fred.hansen",
//     //     "email": null,
//     //     "phone": null,
//     //     "defaultTenant": 7,
//     //     "lastLogin": null,
//     //     "permissions": [
//     //         "SuperAdmin"
//     //     ],
//     //     "frontEndPermissions": [
//     //         2,
//     //         1000,
//     //         1100,
//     //         1101,
//     //         1200,
//     //         1201
//     //     ],
//     //     "iat": 1613678206,
//     //     "exp": 1614283006,
//     //     "iss": "i4 by Digama inc."
//     // }
// }


const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {
    const { id, userId } = action;
    console.log("reducer auth ",action);
    localStorage.setItem('token-id', id)
    localStorage.setItem('userId', userId);
    localStorage.setItem('username', action.username);
    axios.defaults.headers.common['Authorization'] = id;
    instance.defaults.headers.common['Authorization'] = id;
    return updateObject( state, {
        // id: action.id,
        // userId: action.userId,
        error: null,
        loading: false,
        ...action
    } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    clearAuthStorage();
    return updateObject(state, {
        id: null,
        userId: null,
        roleName: null,
        teacherId: null,
        roleLoaded: false,
        error: null
     });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}


const AuthReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case AUTH_START: return authStart(state, action);
        case AUTH_SUCCESS: return authSuccess(state, action);
        case AUTH_FAIL: return authFail(state, action);
        case AUTH_LOGOUT: return authLogout(state, action);
        case SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case AUTH_GETFROMTOKEN_SUCCESS: return updateObject( state, {
            ...state,
            error: null,
            loading: false,
            ...action.payload
        } );
        case AUTH_ROLE_LOADED: {
            localStorage.setItem('roleName', action.roleName);
            return updateObject(state, { roleName: action.roleName, roleLoaded: true });
        }
        case AUTH_TEACHER_LOADED: {
            if (action.teacherId) localStorage.setItem('teacherId', String(action.teacherId));
            return updateObject(state, { teacherId: action.teacherId });
        }
        default:
            return state;
    }
}

export default AuthReducer;
